import MuiListItemButton from '@mui/material/ListItemButton';
import patchButtonBaseComponent from './patch-base-button-components';
export const ListItemButton = patchButtonBaseComponent(MuiListItemButton);
